import HUB_TYPES from "@/lib/hubTypes";

export function useAssetConfig(session) {
  const assetType = session?.asset_type || "refueling";
  const hubConfig = session?.asset_config || {};
  const typeDefaults = HUB_TYPES[assetType] || HUB_TYPES.refueling;

  return {
    assetType,
    isTaskBased: typeDefaults.is_task_based || false,
    actions: hubConfig.actions || typeDefaults.default_actions || [],
    itemA: hubConfig.item_a_label || typeDefaults.item_a.label,
    itemAUnit: hubConfig.item_a_unit || typeDefaults.item_a.unit,
    itemB: hubConfig.item_b_label || typeDefaults.item_b.label,
    itemBUnit: hubConfig.item_b_unit || typeDefaults.item_b.unit,
    itemBEnabled: hubConfig.item_b_enabled !== undefined ? hubConfig.item_b_enabled : typeDefaults.item_b.enabled,
    itemC: hubConfig.item_c_label || typeDefaults.item_c?.label || "",
    itemCUnit: hubConfig.item_c_unit || typeDefaults.item_c?.unit || "",
    itemCEnabled: hubConfig.item_c_enabled || false,
    levelLabel: hubConfig.level_label || typeDefaults.level.label,
    requestLabel: hubConfig.request_label || typeDefaults.request_label,
    deliveryLabel: hubConfig.delivery_label || typeDefaults.delivery_label,
    requestType: hubConfig.request_type_primary || typeDefaults.request_type_primary,
    deliveryVerb: typeDefaults.delivery_verb || "Deliver",
    roleConfig: hubConfig.role_config || "full",
    hasDriver: hubConfig.role_config !== "planner_machinist" && hubConfig.role_config !== "solo",
    hasMachinist: hubConfig.role_config !== "planner_driver" && hubConfig.role_config !== "solo",
  };
}
